import { render, staticRenderFns } from "./ProtocolNumberView.vue?vue&type=template&id=4ab10076&scoped=true&"
import script from "./ProtocolNumberView.vue?vue&type=script&lang=js&"
export * from "./ProtocolNumberView.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolNumberView.vue?vue&type=style&index=0&id=4ab10076&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab10076",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VListItemSubtitle,VListItemTitle,VRow})
